import { NavLink, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, Stack } from "@mui/material";
import React from "react";
import { useTablePDFDownload } from "../utils/GenratePdfA4Table";

export default function MonthlyReport() {
    const navigate = useNavigate();
    const handleNavigateToMonthlyReportDetails = () => {
        navigate('/monthly-report-details');
    }
    
    // =========>> Constant
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();

    // ========================>> useState
    const [dateSelectionView, setDateSelectionView] = useState({
        month: currentMonth,
        year: currentYear,
    });
    const [dateSelectionViewRecordLoading, setDateSelectionViewRecordLoading] = useState();
    
    const [listingDataLoading, setListingDataLoading] = useState(false); 
    const [listingData, setListingData] = useState([]);  

    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

    // Alert message
    const [alertVisible, setAlertVisible] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertSeverity, setAlertSeverity] = useState('success');
  
    // =================>> Print
    const tableRef = useRef(null);
    const downloadTable = useTablePDFDownload(tableRef);

    const handleDateSelectionViewInputChange = (e) => {
        const { name, value } = e.target;
        setDateSelectionView((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    let monthRender = [];
    for (let i = 1; i <=12; i++) {
        monthRender.push(i);
    }

    let yearRender = [];
    for (let i = currentYear; i >= 2024; i--) {
        yearRender.push(i);
    }
    // ========================================================>> Fetch API

    const handleViewRecord = async (event) => {
        event.preventDefault();
        setListingDataLoading(true);
        setListingData([]);
        const monthYear = dateSelectionView.month.toString() + dateSelectionView.year.toString();

        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/monthly-report/by-building?monthYear=${monthYear}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to fetch data.');
            }

            const dataExpense = await response.json();
            setListingData(dataExpense);
        } catch (err) {
            console.error(err.message);
        } finally {
            setListingDataLoading(false);
        }
    }

    const fetchView = async (currentMonthYear) => {
        setListingDataLoading(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/monthly-report/by-building?monthYear=${currentMonthYear}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to fetch data.');
            }

            const dataExpense = await response.json();
            setListingData(dataExpense);
        } catch (err) {
            console.error(err.message);
        } finally {
            setListingDataLoading(false);
        }
    };

    useEffect(() => {
    }, [listingData]); 

    useEffect(() => {

        const currentMonthYear = currentMonth.toString() + currentYear.toString();
        setDateSelectionView({
            month: currentMonth,
            year: currentYear
        })
        fetchView(currentMonthYear);  
    }, []);

    const handleDeleteAllRecords = (e) => {
        e.preventDefault();
        setDeleteDialogOpen(true);
    }

    const confirmDelete = async () => {
        const monthYear = dateSelectionView.month.toString() + dateSelectionView.year.toString();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/monthly-report/month/${monthYear}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error("ទិន្នន័យបរាជ័យក្នុងការលុប"); // Handle non-2xx responses
            }

            setDeleteDialogOpen(false);
            // Show success alert
            setAlertMessage("ទិន្នន័យត្រូវបានលុបដោយជោគជ័យ");
            setAlertSeverity("success");
            setAlertVisible(true);

            setTimeout(() => {
                setAlertVisible(false);
            }, 1000);
            fetchView();
        } catch (error) {
            console.error(error.message);
            setAlertMessage(error.message);
            setAlertSeverity("error");
            setAlertVisible(true);
        }
    }
    
    return (
        <div className="w-full h-[100dvh] bg-white flex flex-col">
            {/* Header */}
            <div className="w-full h-[8dvh] bg-[#0077B6] flex  items-center">
                <div className="md:w-[8%] pl-3 md:pl-10 items-center flex text-customWhite">
                    <NavLink to='/'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-12 text-white">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18" />
                        </svg>
                    </NavLink>
                </div>
                <div className="w-[84%] flex justify-center">
                    <h2 className="text-2xl font-semibold text-customWhite">បញ្ជីប្រចាំខែ</h2>
                </div>
            </div>

            {/* Body */}
            {/* Action buttons */}
            <div className="pt-5">
                <div className="mb-7 flex flex-col md:flex-row justify-center md:justify-stretch w-full lg:px-10">
                    <div className="flex">
                        <button onClick={handleNavigateToMonthlyReportDetails} className="h-14 bg-primary2 hover:bg-primary1 font-medium text-white px-10 ml-5 rounded-lg duration-200">ព័ត៌មានលម្អិត</button>
                        {listingData && listingData.monthYear &&
                            (listingData.monthYear == (currentDate.getMonth() + 1).toString() + currentDate.getFullYear().toString() && currentDate.getDate() < 10 &&
                                <button onClick={handleDeleteAllRecords} className="h-14 bg-red-600 hover:bg-red-700 font-medium text-white px-10 ml-7 rounded-lg duration-200">លុបបញ្ជីប្រចាំខែ</button>
                            )
                        }
                        <button onClick={downloadTable} className="h-14 bg-white hover:bg-gray-200 font-medium text-black   px-10 ml-5 rounded-lg duration-200">↓ ទាញយក</button>
                    </div>
                    <div className="mt-5 md:mt-0 md:ml-auto w-[100%] md:w-[30%] flex justify-center md:justify-stretch">
                        <form className="flex w-[90%] items-center" onSubmit={handleViewRecord}>
                            <FormControl
                            fullWidth
                            margin="dense"
                            sx={{
                                '& .MuiInputLabel-root': {
                                    fontFamily: 'Kantumruy Pro',
                                    fontSize: '16px'
                                },
                                '& .MuiSelect-select': {
                                    fontFamily: 'Kantumruy Pro',
                                    fontSize: '16px'
                                },
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '10px',
                                    boxShadow: '0 1px 2px 0 #D9D9D9, 0 1px 2px 0 #E0E0E0'
                                },
                                marginRight: '15px',
                            }}
                            >
                                <InputLabel>ខែ *</InputLabel>
                                <Select
                                    name="month"
                                    value={dateSelectionView.month || ""}
                                    onChange={handleDateSelectionViewInputChange}
                                    label="ខែ *"
                                >
                                    {
                                        monthRender.map((month, index) => {
                                            return (
                                                <MenuItem key={index} value={month} sx={{fontFamily: 'Kantumruy Pro'}}>
                                                    {month}
                                                </MenuItem>
                                            );
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <FormControl
                            fullWidth
                            margin="dense"
                            sx={{
                                '& .MuiInputLabel-root': {
                                    fontFamily: 'Kantumruy Pro',
                                    fontSize: '16px'
                                },
                                '& .MuiSelect-select': {
                                    fontFamily: 'Kantumruy Pro',
                                    fontSize: '16px'
                                },
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '10px',
                                    boxShadow: '0 1px 2px 0 #D9D9D9, 0 1px 2px 0 #E0E0E0'
                                },
                                marginRight: '15px',
                            }}
                            >
                                <InputLabel>ឆ្នាំ *</InputLabel>
                                <Select
                                    name="year"
                                    value={dateSelectionView.year || ""}
                                    onChange={handleDateSelectionViewInputChange}
                                    label="ឆ្នាំ *"
                                >
                                    {
                                        yearRender.map((year, index) => {
                                            return (
                                                <MenuItem key={index} value={year} sx={{fontFamily: 'Kantumruy Pro'}}>
                                                    {year}
                                                </MenuItem>
                                            );
                                        })
                                    }
                                </Select>
                            </FormControl>
                                <button type="submit" className="h-14 bg-primary2 hover:bg-primary1 font-medium text-white px-6 ml-5 rounded-lg duration-200">
                                    {dateSelectionViewRecordLoading ? 'Loading...' : 'View'}
                                </button>
                        </form>
                    </div>
                </div>

                {/* Table */}
                {listingDataLoading ? (
                    <div className="text-center my-10">
                        <p>Loading data...</p>
                    </div>
                    ) : (
                        <div className="overflow-x-auto overflow-y-auto !h-[76vh]">
                            <table className="table-display w-[100%]" ref={tableRef}>
                                <thead className="!bg-secondary3 border-2">
                                    <tr>
                                        {/* <th className="rounded-tl-lg text-zinc-800  text-xs md:text-sm lg:!text-base">បន្ទប់</th> */}
                                        <th className="text-zinc-800  text-xs md:text-sm lg:!text-base !py-4 ml-3">អគារ</th>
                                        <th className="text-zinc-800  text-xs md:text-sm lg:!text-base !py-4">បន្ទប់សរុប</th>
                                        <th className=" text-zinc-800  text-xs md:text-sm lg:!text-base !py-4">បានបង់</th>
                                        <th className=" text-zinc-800  text-xs md:text-sm lg:!text-base !py-4">មិនទាន់បង់</th>
                                        <th className=" text-zinc-800 text-xs md:text-sm  lg:!text-base !py-4">មិនមានអ្នកជួល</th>
                                        <th className=" text-zinc-800 text-xs md:text-sm lg:!text-base !py-4">តម្លៃត្រូវបង់</th>
                                        <th className=" text-zinc-800 text-xs md:text-sm  lg:!text-base !py-4">តម្លៃទទួលបាន</th>
                                        <th className=" text-zinc-800 text-xs md:text-sm lg:!text-base !py-4">តម្លៃនៅខ្វះ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listingData && listingData.buildings ? (
                                        
                                        listingData.buildings.map((listing, index) => (
                                            <tr key={index} className="even:bg-gray-100 hover:bg-gray-200">
                                                <td className=" text-xs md:text-sm lg:!text-base !py-4 ml-3">{listing.building || 'N/A'}</td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4">
                                                    {listing.total_room !== undefined && listing.total_room !== null 
                                                        ? Math.round(Number(listing.total_room)).toLocaleString() 
                                                        : '--'}
                                                </td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4">
                                                    {listing.paid_room !== undefined && listing.paid_room !== null 
                                                        ? Math.round(Number(listing.paid_room)).toLocaleString() 
                                                        : '--'}
                                                </td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4">
                                                    {listing.unpaid_room !== undefined && listing.unpaid_room !== null 
                                                        ? Math.round(Number(listing.unpaid_room)).toLocaleString() 
                                                        : '--'}
                                                </td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4">
                                                    {listing.not_occupied_room !== undefined && listing.not_occupied_room !== null 
                                                        ? Number(listing.not_occupied_room).toString() 
                                                        : '--'}
                                                </td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4">
                                                    {listing.total_amount_have_to_pay !== undefined && listing.total_amount_have_to_pay !== null 
                                                        ? Number(listing.total_amount_have_to_pay).toLocaleString('en-US') + "$" 
                                                        : '--'}
                                                </td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4">
                                                    {listing.total_amount_already_paid !== undefined && listing.total_amount_already_paid !== null 
                                                        ? Number(listing.total_amount_already_paid).toLocaleString('en-US') + "$" 
                                                        : '--'}
                                                </td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4">
                                                    {listing.total_amount_unpaid_left !== undefined && listing.total_amount_unpaid_left !== null 
                                                        ? Number(listing.total_amount_unpaid_left).toLocaleString('en-US') + "$"
                                                        : '--'}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7">No records found for the selected month and year.</td>
                                        </tr>
                                    )}
                                    {listingData && listingData.total ? (
                                        <tr className=" bg-gray-100 font-semibold shadow-md border-t border-gray-300">
                                            <td className="text-primary1">សរុប</td>
                                            <td>{listingData.total.total_room}</td>
                                            <td>{listingData.total.paid_room}</td>
                                            <td>{listingData.total.unpaid_room}</td>
                                            <td>{listingData.total.not_occupied_room}</td>
                                            <td>{Number(listingData.total.total_amount_have_to_pay).toLocaleString('en-US')}$</td>
                                            <td>{Number(listingData.total.total_amount_already_paid).toLocaleString('en-US')}$</td>
                                            <td>{Number(listingData.total.total_amount_unpaid_left).toLocaleString('en-US')}$</td>
                                        </tr>
                                        ) : (
                                            <tr>
                                                <td>--</td>
                                                <td>--</td>
                                                <td>--</td>
                                                <td>--</td>
                                                <td>--</td>
                                                <td>--</td>
                                                <td>--</td>
                                                <td>--</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                
                        </div>
                        
                    )
                }
                {alertVisible && (
                    <Stack sx={{ width: '100%', justifyContent: "flex-end", position: "fixed",
                        alignItems: "flex-end"}}  mt={-5} spacing={2} borderRadius={2}>
                        <Alert severity={alertSeverity} sx={{fontWeight: 500, fontSize: '16px'}}>
                            {alertMessage}
                        </Alert>
                    </Stack>
                )}
                   
                <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
                    <DialogTitle sx={{ fontFamily: 'Kantumruy Pro', color: 'red', fontSize: '24px'}}>បញ្ជាក់ការលុបបញ្ជីប្រចាំខែ</DialogTitle>
                    <DialogContent>
                        <DialogContentText sx={{ fontFamily: 'Kantumruy Pro', fontSize: '20px'}}>
                            តើអ្នកពិតជាចង់់លុបបញ្ជីប្រចាំខែសម្រាប់ខែ <span className="font-bold text-red-500">{currentDate.getMonth() + 1}</span> មែនទេ?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setDeleteDialogOpen(false)} color="primary" sx={{fontSize: '16px'}}>
                            Cancel
                        </Button>
                        <Button onClick={confirmDelete} color="error" sx={{fontSize: '16px'}}>
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>      
            </div>
        </div>
    )
}